import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";

import {
    EndpointCreditMReports,
    createAPIEndpointCreditMReports,
} from "../../../Services/ReportsAll/CreditManagementReports";
import { Calendar } from "primereact/calendar";
const ReceiptMadeWithinPeriod = () => {
    // const currentDate = format(new Date(), "yyyy-MM-dd");
    // const date = subDays(new Date(), 7);
    // const sevenDays = format(date, "yyyy-MM-dd");
    // const [fromDate, setFromDate] = useState(sevenDays);
    // const [toDate, setToDate] = useState(currentDate);
    const date = subDays(new Date(), 7);
    // const sevenDays = format(date, "yyyy-MM-dd");
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());

    const [loadingExcel, setLoadingExcel] = useState(false);
    const handleExportExcel = (fromDate, toDate) => {
        const auth = storage.getLocal("user");
        setLoadingExcel(true);
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        let uniqueNo = `ReceiptInPeriod${GetDateFormat()}`;
        createAPIEndpointCreditMReports()
            .get(
                `${EndpointCreditMReports.GetExcelDataRcptInPrd}?strFromDateString=${fromDateRange}&strToDateString=${toDateRange}&CompId=${auth.CompId}`
            )
            .then((val) => {
                // console.log(val.data);
                if (val.data.length > 0) {
                    var wb = XLSX.utils.book_new();
                    let MapData = val.data.map((val) => {
                        function transformDate(dateString) {
                            if (!dateString) return "";
                            let updatedData = dateString.replace(/(\d+[/])(\d+[/])/, "$2$1");
                            return new Date(updatedData);
                        }
                        let chequeQR_Transaction_Date = transformDate(
                            val["Cheque/QR Transaction Date"]
                        );
                        let document_Date = transformDate(val["Document Date"]);
                        let relevant_Document_Date = transformDate(
                            val["Relevant Document Date"]
                        );
                        return {
                            ...val,
                            "Cheque/QR Transaction Date": chequeQR_Transaction_Date,
                            "Document Date": document_Date,
                            "Relevant Document Date": relevant_Document_Date,
                        };
                    });
                    var ws = XLSX.utils.json_to_sheet(MapData);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                } else {
                    toast.warning("No data found between these dates", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }
                setLoadingExcel(false);
            })
            .catch((err) => {
                toast.error(`${err.response.data}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            });
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <h3 className="py-2">Receipt Made Within A Period</h3>
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => {
                                    setFromDate(e.target.value);
                                }}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="text-end">
                                <button
                                    disabled={loadingExcel}
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        handleExportExcel(fromDate, toDate);
                                    }}
                                >
                                    {loadingExcel ? "Loading..." : "Save as Excel"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaFileExport className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );
};

export default ReceiptMadeWithinPeriod;
